import ContactFormSection from '../../../component/contact/ContactFormSection';

export default function ContactSection({ sectionId }) {
  return (
 <>
   <ContactFormSection apiEndpoint="https://cp.cloudkodeform.com/api/contact-us/create" />
 </>
  );
}
